export const normalizarTextoCategoria = (valor) => {
  return String(valor || "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();
};

export const crearIdCategoria = (turno, categoria) => {
  const turnoNormalizado = normalizarTextoCategoria(turno || "GENERAL")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  const categoriaNormalizada = normalizarTextoCategoria(categoria)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `${turnoNormalizado}_${categoriaNormalizada}`;
};

export const ordenarCategoriasPorConfiguracion = (
  categoriasDetectadas = [],
  categoriasConfiguradas = [],
  turnoActivo = "",
) => {
  const turnoNormalizado = normalizarTextoCategoria(turnoActivo);
  console.log("TURNO ACTIVO:", turnoNormalizado);
  console.log("CATEGORÍAS CONFIGURADAS:", categoriasConfiguradas);
  console.log("CATEGORÍAS DETECTADAS:", categoriasDetectadas);
  const configsDelTurno = categoriasConfiguradas
    .filter((categoriaConfig) => {
      const turnoCategoria = normalizarTextoCategoria(categoriaConfig.turno);

      return (
        categoriaConfig.activa !== false &&
        (!turnoNormalizado ||
          turnoCategoria === turnoNormalizado ||
          turnoCategoria === "GENERAL")
      );
    })
    .sort((a, b) => Number(a.orden || 9999) - Number(b.orden || 9999));

  const ordenPorCategoria = new Map();

  configsDelTurno.forEach((categoriaConfig) => {
    ordenPorCategoria.set(
      normalizarTextoCategoria(categoriaConfig.nombre),
      Number(categoriaConfig.orden || 9999),
    );
  });

  return [...categoriasDetectadas].sort((a, b) => {
    const categoriaA = normalizarTextoCategoria(a);
    const categoriaB = normalizarTextoCategoria(b);

    const ordenA = ordenPorCategoria.has(categoriaA)
      ? ordenPorCategoria.get(categoriaA)
      : 9999;

    const ordenB = ordenPorCategoria.has(categoriaB)
      ? ordenPorCategoria.get(categoriaB)
      : 9999;

    if (ordenA !== ordenB) {
      return ordenA - ordenB;
    }

    return categoriaA.localeCompare(categoriaB, "es");
  });
};

export const validarSaltosOrdenCategorias = (categorias = []) => {
  const ordenes = categorias
    .map((categoria) => Number(categoria.orden))
    .filter((orden) => Number.isFinite(orden) && orden > 0)
    .sort((a, b) => a - b);

  const faltantes = [];

  for (let i = 1; i <= ordenes.length; i += 1) {
    if (!ordenes.includes(i)) {
      faltantes.push(i);
    }
  }

  return {
    valido: faltantes.length === 0,
    faltantes,
  };
};
